export function trimmedStringOrNull(value?: string | null): string | null {
  const result = !value || value?.trim().length === 0 ? null : value?.trim()
  return result
}
